import { useTranslation } from 'react-i18next';
import styles from './BackButton.scss';

export interface BackButton_Props {
    onClick?: () => void,
}

const BackButton = (props: BackButton_Props) => {
    const { t } = useTranslation();

    return (
        <div className={styles.wrapper} onClick={props.onClick}>
            {t('Назад')}
        </div>
    );
};

export default BackButton;
